<template>
  <div class="buysDataBox">
    <div class="title">
      <div class="titleIcon" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <h2>充值记录</h2>
      <!-- <div class="goBackBox">
        <el-button type="primary" @click="goBack" class="goBackBtn">
          <i class="el-icon-back"></i>
        </el-button>
      </div> -->
    </div>
    <div class="talksBox scrollStyle">
      <template v-if="buysData.length">
        <div class="payCard" v-for="(item, index) in buysData" :key="index">
          <div class="repordNum">订单号：{{ item.orderNo }}</div>
          <div class="repordContent">
            <el-row>
              <el-col :span="12">充值金额：￥{{ item.amount }}</el-col>
              <el-col :span="12">充值额度：{{ item.number }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">充值时间：{{ item.createdTime }}</el-col>
              <el-col :span="12">过期时间：{{ item.expires }}</el-col>
            </el-row>
          </div>
        </div>
      </template>
      <template v-else>
        <el-empty description="暂无数据"></el-empty>
      </template>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: 'BuysData',
  components: {},
  props: {},
  data () {
    return {
      getOrders: api.getOrders,
      buysData: [], // 充值记录
      Infinite: -1,
      repordList: [
        // {
        //   orderNo: '36533322233',
        //   amount: '9.9',
        //   number: '',
        //   createdTime: '2024.4.12 17:44',
        //   expires: '2024.4.15 17:44',
        // },
        // {
        //   orderNo: '36533322233',
        //   amount: '9.9',
        //   number: '',
        //   createdTime: '2024.4.12 17:44',
        //   expires: '2024.4.15 17:44',
        // },
        // {
        //   orderNo: '36533322233',
        //   amount: '9.9',
        //   number: '',
        //   createdTime: '2024.4.12 17:44',
        //   expires: '2024.4.15 17:44',
        // },
        // {
        //   orderNo: '36533322233',
        //   amount: '9.9',
        //   number: '',
        //   createdTime: '2024.4.12 17:44',
        //   expires: '2024.4.15 17:44',
        // },
        // {
        //   orderNo: '36533322233',
        //   amount: '9.9',
        //   number: '',
        //   createdTime: '2024.4.12 17:44',
        //   expires: '2024.4.15 17:44',
        // },
        // {
        //   orderNo: '36533322233',
        //   amount: '9.9',
        //   number: '',
        //   createdTime: '2024.4.12 17:44',
        //   expires: '2024.4.15 17:44',
        // },
      ],
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.toGetOrders();
  },
  methods: {
    //获取充值记录
    toGetOrders() {
      // this.loading = true;
      this.getOrders()
        .then((res) => {
          // console.log(res.data);
          if (res.success) {
            this.buysData = res.data.map((p) => ({
              ...p,
              number: p.number == this.Infinite ? "不限" : p.number.toString(),
            }));
          }
          // this.loading = false;
        })
        .catch((e) => {
          // this.loading = false;
        });
    },
    goBack() {
      this.$emit('goBack');
    },
  }
}
</script>

<style scoped lang="less">
.buysDataBox {
  width: 100%;
  height: 100%;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    display: flex;
    // justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 18px;
      font-weight: 600;
    }
    .titleIcon {
      cursor: pointer;
      margin-right: 10px;
      i {
        color: #aaa;
        font-size: 24px;
      }
    }
    // .goBackBox {
    //   .goBackBtn {
    //     background: #2f80ec;
    //     width: 20px;
    //     height: 20px;
    //     border-radius: 5px;
    //     display: inline-block;
    //     line-height: 20px;
    //     text-align: center;
    //     padding: 0;
    //     border: 0;
    //     i{
    //       font-size: 18px;
    //       color: #fff;
    //     }
    //   }
    // }
  }
  .talksBox {
      height: calc(100% - 22px - 30px);
      flex: 1;
      overflow-y: auto;
      padding-right: 3px;
      position: relative;

      .payCard {
        background: #fff;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;
        .repordNum {
          font-size: 14px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
          margin-bottom: 10px;
        }
        .repordContent {
          font-size: 12px;
          line-height: 24px;
          color: #666;
        }
      }
    }
}
</style>
